import CONSTANTS from '@/constants'
import { differenceInSeconds } from 'date-fns'

export const lastActiveVoucher = activeVouchers => {
  if (activeVouchers?.length) {
    return activeVouchers[0]
  }
  return null
}

export const hasPassedAttempt = attempt => {
  let practice = true
  if (!attempt) return false
  if (attempt.practice_lab) {
    if (attempt.user_lab_attempt) {
      practice = attempt.user_lab_attempt.has_passed
    } else {
      practice = false
    }
  }
  return (
    attempt.status === CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.FINISHED &&
    attempt.has_passed &&
    practice
  )
}

export const attemptInReview = attempt => {
  if (
    attempt &&
    attempt.status === CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.REVIEW
  ) {
    return attempt
  }
  return null
}

export const attemptFailed = attempt => {
  if (
    attempt &&
    (attempt.status === CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.FINISHED ||
      attempt.status === CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.TIMEDOUT) &&
    !hasPassedAttempt(attempt)
  ) {
    return attempt
  }
  return null
}

export const attemptInProgress = attempt => {
  if (
    attempt &&
    attempt.status === CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.IN_PROGRESS &&
    differenceInSeconds(
      new Date(attempt.expiration_date).getTime(),
      new Date().getTime()
    ) >= 0
  ) {
    return attempt
  }
  return null
}

export const activeVouchers = certification => {
  if (!certification.user_status) return null
  return certification.user_status.active_vouchers
}

export const inactiveVouchers = certification => {
  if (!certification.user_status) return null
  return certification.user_status.inactive_vouchers
}

export const lastAttempt = certification => {
  let allAttempts = []
  const actVouchers = activeVouchers(certification)
  if (actVouchers?.length) {
    actVouchers.map(voucher => {
      allAttempts = [...allAttempts, ...voucher.active_attempts]
      allAttempts = [...allAttempts, ...voucher.inactive_attempts]
    })
  }
  const inactVouchers = inactiveVouchers(certification)
  if (inactVouchers?.length) {
    inactVouchers.map(voucher => {
      allAttempts = [...allAttempts, ...voucher.active_attempts]
      allAttempts = [...allAttempts, ...voucher.inactive_attempts]
    })
  }
  return allAttempts.length ? allAttempts[0] : null
}

export const canDoARetake = certification => {
  if (certification.user_status) {
    const activeVoucher = lastActiveVoucher(
      certification.user_status.active_vouchers
    )
    const attempt = lastAttempt(certification)
    return (
      activeVoucher &&
      activeVoucher.remaining_attempts &&
      activeVoucher.next_attempt_expiration_date &&
      attemptFailed(attempt)
    )
  }
  return false
}

export const noVouchers = certification => {
  const attempt = lastAttempt(certification)
  return (
    !attemptInReview(attempt) &&
    !hasPassedAttempt(attempt) &&
    !activeVouchers(certification)?.length &&
    certification.user_status
  )
}

export const lastVoucher = certification => {
  const actVouchers = activeVouchers(certification)
  const inactVouchers = inactiveVouchers(certification)

  if (actVouchers?.length) {
    return actVouchers[0]
  }
  if (inactVouchers?.length) {
    return inactVouchers[0]
  }
  return null
}

export const certInBeta = certification => {
  return (
    certification?.versions?.[0]?.is_beta ||
    lastVoucher(certification)?.certification_version?.is_beta
  )
}

export const hasUserStatus = certification => {
  return certification.awarded || certification.user_status
}

export const certificationUserStatus = certification => {
  const attempt = lastAttempt(certification)

  if (
    certInBeta(certification) &&
    (!hasUserStatus(certification) || noVouchers(certification))
  ) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.NOT_AVAILABLE
  }

  if (noVouchers(certification)) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.NO_VOUCHERS
  }

  if (canDoARetake(certification)) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.CAN_DO_RETAKE
  }

  if (attemptInReview(attempt)) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.ATTEMPT_IN_REVIEW
  }

  if (attemptInProgress(attempt)) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.ATTEMPT_IN_PROGRESS
  }

  if (hasPassedAttempt(attempt)) {
    return CONSTANTS.CERTIFICATIONS.USER_STATUS.AWARDED
  }

  return CONSTANTS.CERTIFICATIONS.USER_STATUS.READY_FOR_FIRST_ATTEMPT
}

export const canNotTakeExam = certification => {
  // when we have to buy:
  // no cert
  // no user
  // no voucher
  // no attempt and no progress, review or passed
  // no matters about attempts, but no active and no progress, review or passed
  let voucher = null
  let attempt = null
  if (certification && certification.user_status) {
    voucher = lastVoucher(certification)
    attempt = lastAttempt(certification)
    return (
      !voucher ||
      (!voucher.remaining_attempts &&
        !attemptInProgress(attempt) &&
        !attemptInReview(attempt) &&
        !hasPassedAttempt(attempt)) ||
      (!lastActiveVoucher(certification.user_status.active_vouchers) &&
        !attemptInProgress(attempt) &&
        !attemptInReview(attempt) &&
        !hasPassedAttempt(attempt))
    )
  }

  return true
}

export const certLatestVersion = certification => {
  return certification.versions?.[0]
}
